import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .opening-hours-modal {
    width: 420px;
    padding: 16px;
  }
  .opening-hours-modal-inputs {
    width: 100%;
    padding-bottom: 16px;
  }
  .opening-hours-modal-wrapper {
    margin-bottom: 8px;
  }
  .opening-hours-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
    background-color: black;
  }
  .opening-hours-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
    background-color: black;
  }
  .opening-hours-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .opening-hours-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
  .opening-hours-title {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: 600;
  }
`;

export default style;
